'use client';

import { useRouter } from 'next/navigation';
import { usePathname } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { i18nConfig } from '@/i18n/i18nConfig';
import * as React from 'react';
import { Theme, useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';

import Select, { SelectChangeEvent } from '@mui/material/Select';
import { Box, FormControlLabel, Radio, Typography } from '@mui/material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  { label: 'English (EN)', value: 'en-US' },
  { label: 'French (FR)', value: 'fr-CA' },
];

let shortName: any = {
  ['English (EN)']: 'EN',
  ['French (FR)']: 'FR',
};

let localeName: any = {
  'en-US': 'EN',
  'fr-CA': 'FR',
};

function getStyles(name: string, personName: string = '', theme: Theme) {
  return {
    fontWeight: personName.includes(name)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}
export default function LanguageChanger() {
  const { i18n } = useTranslation();
  const currentLocale = i18n.language;
  const router = useRouter();
  const currentPathname = usePathname();
  const theme = useTheme();
  const { t } = useTranslation('languageSwitcher');

  const [locale, setLocale] = React.useState<string>(localeName[currentLocale]);

  const handleChange = (event: SelectChangeEvent<typeof locale>) => {
    const {
      target: { value },
    } = event;

    const localeValue = value; // value like en-US,fr-CA
    const newLocale = localeName[value];

    // set cookie for next-i18n-router
    const days = 30;
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = date.toUTCString();
    document.cookie = `NEXT_LOCALE=${newLocale};expires=${expires};path=/`;

    // redirect to the new locale path
    if (currentLocale === i18nConfig.defaultLocale) {
      router.push('/' + value + currentPathname);
    } else {
      router.push(currentPathname.replace(`/${currentLocale}`, `/${value}`));
    }

    router.refresh();
    setLocale(value);
  };

  return (
    <Box>
      <Select
        sx={{ boxShadow: 'none', '.MuiOutlinedInput-notchedOutline': { borderStyle: 'none' } }}
        displayEmpty
        name="language-switcher"
        size="small"
        slotProps={{
          input: {
            'aria-label': 'language-switcher-button',
            name: 'language-switcher',
          },
        }}
        value={currentLocale}
        label={'abc'}
        onChange={handleChange}
        input={<OutlinedInput />}
        className="language-switcher"
        MenuProps={{
          className: 'menu-wrapper',
        }}
        // open
        renderValue={selected => {
          return localeName[selected] ? localeName[selected] : selected;
        }}
        inputProps={{ className: '' }}
      >
        <Typography className="choose-language" variant="subtitle1">
          {t('changeLanguage')}
        </Typography>
        {names.map(name => (
          <MenuItem key={name.value} value={name.value} className="language-menu-item">
            <FormControlLabel
              style={getStyles(name.label, locale, theme)}
              value={name.value}
              control={<Radio size="small" checked={locale === shortName[name.label]} />}
              label={name.label}
              className="language-radio-btn"
            />
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}
